<ion-header class="ion-no-border">

  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">
        <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      Remove store credit
      @if (!loading && organisation) {
        <p class="subtitle">{{organisation.title}}</p>
      }
    </ion-title>
    @if (online && !loading) {
      <ion-buttons slot="end">
        <ion-button (click)="remove()">
          <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
        </ion-button>
      </ion-buttons>
    }
  </ion-toolbar>

</ion-header>

<ion-content>

  @if (online && !loading) {
    <ion-grid class="form">
      <ion-row>
        <ion-col>
          <ion-grid class="fieldset">
            @if (supported_currencies && supported_currencies.length > 1) {
              <ion-row>
                <ion-col>
                  <ion-select okText="OK" interface="alert" [interfaceOptions]="currency_options" label="Currency" labelPlacement="stacked" fill="outline" (ionChange)="setStoreCredit()" [(ngModel)]="currency_id">
                    @for (currency of supported_currencies; track currency) {
                      <ion-select-option value="{{currency.id}}">{{currency.title}}</ion-select-option>
                    }
                  </ion-select>
                </ion-col>
              </ion-row>
            }
            @if (store_credit) {
              <ion-row>
                <ion-col>
                  <h5>Balance</h5>
                  <p class="prominent">{{store_credit.currency.sign}}{{store_credit.balance | number:'1.2'}}</p>
                </ion-col>
              </ion-row>
            }
            <ion-row>
              <ion-col>
                <ion-input #amount_input type="tel" inputmode="decimal" maxlength="10" label="Amount" labelPlacement="stacked" fill="outline" [(ngModel)]="params.amount"></ion-input>
              </ion-col>
            </ion-row>
            <ion-row>
              <ion-col>
                <ion-textarea type="text" inputmode="text" maxlength="1000" [autoGrow]="true" rows="5" label="Internal note" labelPlacement="stacked" fill="outline" [(ngModel)]="params.internal_note"></ion-textarea>
              </ion-col>
            </ion-row>
            @if (xero_connected) {
              <ion-row>
                <ion-col>
                  <ion-item lines="none" class="ion-no-padding">
                    <ion-toggle class="form-toggle" alignment="start" label-placement="stacked" [(ngModel)]="params.add_xero_manual_journal">Add store credit liability in Xero</ion-toggle>
                  </ion-item>
                </ion-col>
              </ion-row>
            }
          </ion-grid>
        </ion-col>
      </ion-row>
    </ion-grid>
  }

</ion-content>
